import { TableContainer } from "./TableContainer";
import { TextEllipsis } from "./TextEllipsis";

export const UI = {
  TableContainer,
  TextEllipsis,
};
